@if (isLoading$ | async) {
  <div class="loader-overlay">
    <div class="loader-spinner">
      <div class="spinner"></div>
    </div>
  </div>
}
